import { useCpmsBoGetRevenueByConnectorTypeQuery } from '@service/cpms-bo-transaction-reports-revenue-statistics.service';

import {
  ByConnectorTypeCard,
  ByConnectorTypeCardVariantEnum,
} from '../../components/by-connector-type-card/by-connector-type.card';
import { useFilters } from '../../context/filters.context';

export const RevenueByConnectorTypeCard = (): React.JSX.Element => {
  const { transformedFilters } = useFilters();
  const { data } = useCpmsBoGetRevenueByConnectorTypeQuery({
    ...transformedFilters,
  });

  return (
    <ByConnectorTypeCard
      data={data}
      variant={ByConnectorTypeCardVariantEnum.Revenue}
    />
  );
};
